import React from 'react'
import { Button } from '@chakra-ui/react'

export const ReturnButton = ({ onClick, children = 'アプリに戻る', ...props }) => (
  <Button
    w="100%"
    h="40px"
    bg="white"
    color="#444444"
    fontSize="sm"
    fontWeight="600"
    border="1px solid"
    borderColor="#e0e0e0"
    onClick={onClick}
    _hover={{ opacity: 0.8 }}
    {...props}
  >
    {children}
  </Button>
)
